type MusicTrackProps = {
    title: string;
    url: string;
};

export default class MusicTrack {
    title: string;

    url: string;

    constructor({ title, url }: MusicTrackProps) {
        this.title = title;
        this.url = url;
    }
}
